import './Footer.scss'

export function Footer() {
  return <div className="footer-container" />
}
